import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<header className="site-header" style={{ position: 'sticky', top: 0, zIndex: 30 }}>
			{/* Top bar */}
			<div className="header-topbar">
				<div className="container topbar-inner">
					<div className="topbar-left">
						<a href="tel:+16023902536" className="topbar-link">
							<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C9.61 21 3 14.39 3 6.5a1 1 0 0 1 1-1H7.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							(602) 390-2536
						</a>
						<a href="mailto:info@azhomefundingservices.com" className="topbar-link">
							<svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="m2 7 10 7 10-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
							info@azhomefundingservices.com
						</a>
					</div>
					<div className="topbar-social">
						<a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
							<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
						</a>
						<a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
							<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></svg>
						</a>
						<a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
							<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
						</a>
						<a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X / Twitter">
							<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
						</a>
					</div>
				</div>
			</div>

			{/* Main nav */}
			<div className="header-main">
				<div className="container row" style={{ height: 64 }}>
					<Link to="/" className="brand" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
						{/* House icon logo */}
						<svg width="36" height="36" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect width="40" height="40" rx="8" fill="#c45c14"/>
							<path d="M8 22l12-12 12 12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
							<path d="M12 18v10h6v-6h4v6h6V18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
						<div className="brand-text">
							<span className="brand-name">A-Z Home Improvement</span>
							<span className="brand-sub">Licensed Remodeling Contractor</span>
						</div>
					</Link>

					<button
						className="mobile-menu-btn"
						onClick={() => setMenuOpen(!menuOpen)}
						aria-label="Toggle navigation"
						aria-expanded={menuOpen}
					>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
							{menuOpen
								? <path d="M6 6l12 12M6 18L18 6" stroke="#1c1917" strokeWidth="2" strokeLinecap="round"/>
								: <path d="M4 6h16M4 12h16M4 18h16" stroke="#1c1917" strokeWidth="2" strokeLinecap="round"/>
							}
						</svg>
					</button>

					<nav className={`nav${menuOpen ? ' nav-open' : ''}`} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
						<NavLink to="/services" onClick={() => setMenuOpen(false)} style={({ isActive }) => ({ fontWeight: 600, textDecoration: 'none', color: isActive ? '#c45c14' : '#1c1917', padding: '6px 10px', borderRadius: 6 })}>Services</NavLink>
						<NavLink to="/gallery" onClick={() => setMenuOpen(false)} style={({ isActive }) => ({ fontWeight: 600, textDecoration: 'none', color: isActive ? '#c45c14' : '#1c1917', padding: '6px 10px', borderRadius: 6 })}>Our Work</NavLink>
						<NavLink to="/service-areas" onClick={() => setMenuOpen(false)} style={({ isActive }) => ({ fontWeight: 600, textDecoration: 'none', color: isActive ? '#c45c14' : '#1c1917', padding: '6px 10px', borderRadius: 6 })}>Service Areas</NavLink>
						<NavLink to="/faq" onClick={() => setMenuOpen(false)} style={({ isActive }) => ({ fontWeight: 600, textDecoration: 'none', color: isActive ? '#c45c14' : '#1c1917', padding: '6px 10px', borderRadius: 6 })}>FAQ</NavLink>
						<NavLink to="/about" onClick={() => setMenuOpen(false)} style={({ isActive }) => ({ fontWeight: 600, textDecoration: 'none', color: isActive ? '#c45c14' : '#1c1917', padding: '6px 10px', borderRadius: 6 })}>About</NavLink>
						<Link to="/contact" onClick={() => setMenuOpen(false)} className="nav-cta" style={{ marginLeft: 8, textDecoration: 'none' }}>
							Get a Free Quote
						</Link>
					</nav>
				</div>
			</div>
		</header>
	);
}

export default Header;
